import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';

/**
 * Distribuição de gordura: padrão androide (central) ou ginoide (periférico).
 * Referência clínica: classificação de Jean Vague e estudos de risco
 * cardiometabólico pela razão androide/ginoide (DXA, cintura/quadril).
 * Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/fat_distribution.php.
 */
const fatDistribution = {
  key: 'fat_distribution',
  name: 'Distribuição de gordura',
  description: 'Onde a gordura se concentra: androide ou ginoide',
  details: 'Indica onde a gordura corporal se acumula mais: no abdome e no tronco (androide, formato de maçã) ou no quadril, nos glúteos e nas coxas (ginoide, formato de pera). O padrão androide está ligado a mais gordura visceral e a maior risco cardiometabólico, o que ajuda a orientar o plano e o acompanhamento. Um clique marca o padrão do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: AccessibilityNewOutlinedIcon,
  accent: 'blue',
  options: [
    {
      value: 'android',
      label: 'Androide',
      caption: 'Abdome e tronco',
      image: 'distribuicao-gordura-1.png',
      help: 'Gordura concentrada no abdome e no tronco, em formato de maçã. Costuma vir com mais gordura visceral e está associada a maior risco cardiometabólico (resistência à insulina, diabetes tipo 2, hipertensão e alteração do colesterol).',
    },
    {
      value: 'gynoid',
      label: 'Ginoide',
      caption: 'Quadril, glúteos e coxas',
      image: 'distribuicao-gordura-2.png',
      help: 'Gordura concentrada no quadril, nos glúteos e nas coxas, em formato de pera. Em geral é mais subcutânea e está associada a menor risco cardiometabólico que o padrão androide.',
    },
  ],
};

export default fatDistribution;
